import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  CurrencyPipe
} from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { MatMenuModule } from '@angular/material/menu';

import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import {
  ModuleRegistry,
  InfiniteRowModelModule,
  PaginationModule,
  ColumnApiModule,
  RowSelectionModule,
  RowAutoHeightModule,
  CellStyleModule,
  ValidationModule,
  RowApiModule,
  ClientSideRowModelApiModule,
  RenderApiModule,
  RowStyleModule,
  DateFilterModule,
  DateEditorModule,
  NumberEditorModule,
  NumberFilterModule,
  TextEditorModule,
  TextFilterModule,

} from 'ag-grid-community';
import {
  ServerSideRowModelModule,
  MasterDetailModule,
  RichSelectModule,
  ColumnsToolPanelModule,
  LicenseManager,
  SetFilterModule
} from 'ag-grid-enterprise';

import { PtlXhrModule } from '@ptl/xhr';
import { CookieService } from 'ngx-cookie-service';
import { NgReduxModule } from '@ptl/angular-redux-store';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { ProducerLandingPageComponent } from './producer-landing-page/producer-landing-page.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { ProducerDashboardComponent } from './producer-dashboard/producer-dashboard.component';
import { ApplicationCardComponent } from './application-card/application-card.component';
import {
  NgReduxFormConnectModule,
  NgReduxFormConnectArrayModule
} from '@ptl/angular-redux-form';
import { AgencyPageComponent } from './agency-page/agency-page.component';
import { PurlDashboardComponent } from './purl-dashboard/purl-dashboard.component';
import { PurlStatusCardComponent } from './purl-status-card/purl-status-card.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { PtlGlobalComponentsModule } from '@ptl/global-components';
import { PtlAccountManagementModule } from '@ptl/account-management';
import { ProducerLinesOfBusinessComponent } from './producer-lines-of-business/producer-lines-of-business.component';
import { ProducerChangeAgencyComponent } from './producer-change-agency/producer-change-agency.component';
import { SSOHandlerComponent } from './sso-handler/sso-handler.component';
import { Broker360SSOComponent } from './ssos/broker360-sso/broker360-sso.component';
import { MarcomSSOComponent } from './ssos/marcom-sso/marcom-sso.component';
import { AgentCubedSSOComponent } from './ssos/agent-cubed-sso/agent-cubed-sso.component';
import { HeeterSSOComponent } from './ssos/heeter-sso/heeter-sso.component';
import { ProducerReportsComponent } from './producer-reports/producer-reports.component';
import { ProducerReportsListComponent } from './producer-reports/producer-reports-list/producer-reports-list.component';
import { ProducerReportsGenerateComponent } from './producer-reports/producer-reports-generate/producer-reports-generate.component';
import { ResourcesListComponent } from './resources-list/resources-list.component';
import { ResourcesListEmailComponent } from './resources-list/email-modal/resources-list-email/resources-list-email.component';
import { ProducerCompactAgencyComponent } from './producer-compact-agency/producer-compact-agency.component';
import { ProducerChangeAgencyModalComponent } from './producer-change-agency/producer-change-agency-modal/producer-change-agency-modal.component';
import { PlanAdvisorSsoComponent } from './ssos/plan-advisor-sso/plan-advisor-sso.component';
import { ApmSsoComponent } from './ssos/apm-sso/apm-sso.component';
import { ProducerLoginAsEmployerComponent } from './producer-login-as-employer/producer-login-as-employer.component';
import { HealthSherpaSSOComponent } from './ssos/health-sherpa-sso/components/header/health-sherpa-sso.component';
import { HealthSherpaSsoPageInterstitialComponent } from './ssos/health-sherpa-sso/components/page/health-sherpa-sso-page-interstitial.component';
import { SoaDashboardComponent } from './soa-dashboard/soa-dashboard.component';
import { SoaCardComponent } from './soa-card/soa-card.component';
import { BenefitsManagerSsoComponent } from './ssos/benefits-manager-sso/benefits-manager-sso.component';
import { StaticReportsDownloadComponent } from './producer-reports/static-reports-download/static-reports-download.component';
import { BookOfBusinessModalComponent } from './producer-reports/static-reports-download/book-of-business-modal/book-of-business-modal.component';
import { RateGuidesDownloadComponent } from './producer-reports/rate-guides-download/rate-guides-download.component';
import { CurtisDirectSSOComponent } from './ssos/curtis-direct-sso/curtis-direct-sso.component';
import { MinnesotaPopUpWhyComponent } from './producer-reports/producer-reports-generate/minnesota-pop-up-why/minnesota-pop-up-why.component';
import { environment } from 'src/environments/environment';
import { EbillSsoComponent } from './ssos/ebill-sso/ebill-sso.component';
import { ResourceDownloadComponent } from './resource-download/resource-download.component';
import { PlanAdvisorV2SsoComponent } from './ssos/plan-advisor-v2-sso/plan-advisor-v2-sso.component';
import { MassEnrollmentComponent } from './mass-enrollment/mass-enrollment.component';
import { MassUploadComponent } from './mass-upload/mass-upload.component';
import { SubmissionLogComponent } from './submission-log/submission-log.component';
import { StateBasedFindADoctorComponent } from './state-based-find-a-doctor/state-based-find-a-doctor.component';
import { SalesForceSsoComponent } from './ssos/sales-force-sso/sales-force-sso.component';
import { SalesForceTestSsoComponent } from './ssos/sales-force-test-sso/sales-force-test-sso.component';
import { CavulusSsoComponent } from './ssos/cavulus-sso/cavulus-sso.component';
import { SaveQuoteCardComponent } from './save-quote-card/save-quote-card.component';
import { SaveQuoteModalComponent } from './save-quote-modal/save-quote-modal.component';
import { SavedQuotesComponent } from './saved-quotes/saved-quotes.component';
import { SaveQuoteEmailReferralModalComponent } from './save-quote-email-referral-modal/save-quote-email-referral-modal.component';
import { ViewPlanComponent } from './view-plan/view-plan.component';
import { SalesForceUatSsoComponent } from './ssos/sales-force-uat-sso/sales-force-uat-sso.component';
import { PassiveReferralsComponent } from './passive-referrals/passive-referrals.component';
import { PassiveReferralLoaderComponent } from './passive-referral-loader/passive-referral-loader.component';
import { ConnectureEnrollSsoComponent } from './ssos/connecture-enroll/connecture-enroll-sso.component';
import { FieldAgentConfirmModalComponent } from './ssos/connecture-enroll/field-agent-confirm-modal/field-agent-confirm-modal.component';
import { MediaCardComponent } from './media-selection/media-card/media-card.component';
import { MediaListComponent } from './media-selection/media-list/media-list.component';
import { DynamicLinkLayoutComponent } from './dynamic-link-layout/dynamic-link-layout.component';
import { StateModuleReadyService } from '@ptl/state';
import { MassUploadGridComponent } from './mass-upload-grid/mass-upload-grid.component';
import { MassUploadGridDashboardComponent } from './mass-upload-grid/mass-upload-grid-dashboard/mass-upload-grid-dashboard.component';
import { MassUploadGridSubmissionLogComponent } from './mass-upload-grid/mass-upload-grid-submission-log/mass-upload-grid-submission-log.component';
import { PtlFormsModule } from '@ptl/forms';
import { MassUploadDisplayPipe } from './mass-upload-grid/mass-upload-grid-display-pipe/mass-upload-grid-display-pipe';
import { SepDocumentUploadStatusIndicatorComponent } from './save-quote-card/sep-document-upload-status-indicator/sep-document-upload-status-indicator.component';
import { SepApplicationReviewDashboardComponent } from './sep-application-review-dashboard/sep-application-review-dashboard.component';
import { SepApplicationReviewGridComponent } from './sep-application-review-dashboard/sep-application-review-grid/sep-application-review-grid.component';
import { UploadDocumentsModalComponent } from './sep-application-review-dashboard/sep-application-review-grid/upload-documents-modal/upload-documents-modal.component';
import { RequiredDocsUploadModule } from '../form-wrappers/form-components/required-docs-upload/required-docs-upload.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialGlobalModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgReduxModule,
    PtlXhrModule,
    PtlFormsModule,
    ReducersRegistryModule,
    SharedComponentsModule,
    NgReduxFormConnectModule,
    NgReduxFormConnectArrayModule,
    PtlGlobalComponentsModule,
    PtlAccountManagementModule.forRoot(environment),
    GoogleChartsModule,
    AgGridModule,
    AgGridAngular,
    MatMenuModule,
    RequiredDocsUploadModule
  ],
  declarations: [
    ProducerLandingPageComponent,
    ProducerDashboardComponent,
    ApplicationCardComponent,
    AgencyPageComponent,
    PurlDashboardComponent,
    PurlStatusCardComponent,
    ProducerLinesOfBusinessComponent,
    ProducerChangeAgencyComponent,
    SSOHandlerComponent,
    Broker360SSOComponent,
    MarcomSSOComponent,
    AgentCubedSSOComponent,
    HeeterSSOComponent,
    EbillSsoComponent,
    ProducerReportsComponent,
    ProducerReportsListComponent,
    ProducerReportsGenerateComponent,
    ResourcesListComponent,
    ResourcesListEmailComponent,
    ProducerCompactAgencyComponent,
    ProducerChangeAgencyModalComponent,
    PlanAdvisorSsoComponent,
    ApmSsoComponent,
    ProducerLoginAsEmployerComponent,
    HealthSherpaSSOComponent,
    HealthSherpaSsoPageInterstitialComponent,
    SoaDashboardComponent,
    SoaCardComponent,
    BenefitsManagerSsoComponent,
    StaticReportsDownloadComponent,
    BookOfBusinessModalComponent,
    RateGuidesDownloadComponent,
    CurtisDirectSSOComponent,
    MinnesotaPopUpWhyComponent,
    ResourceDownloadComponent,
    PlanAdvisorV2SsoComponent,
    MassEnrollmentComponent,
    MassUploadComponent,
    MassUploadGridComponent,
    MassUploadGridDashboardComponent,
    MassUploadGridSubmissionLogComponent,
    SubmissionLogComponent,
    StateBasedFindADoctorComponent,
    SalesForceSsoComponent,
    SalesForceTestSsoComponent,
    SalesForceUatSsoComponent,
    ConnectureEnrollSsoComponent,
    CavulusSsoComponent,
    SaveQuoteCardComponent,
    SepDocumentUploadStatusIndicatorComponent,
    SaveQuoteModalComponent,
    SavedQuotesComponent,
    SaveQuoteEmailReferralModalComponent,
    ViewPlanComponent,
    PassiveReferralsComponent,
    PassiveReferralLoaderComponent,
    FieldAgentConfirmModalComponent,
    MediaCardComponent,
    MediaListComponent,
    DynamicLinkLayoutComponent,
    MassUploadDisplayPipe,
    SepApplicationReviewDashboardComponent,
    SepApplicationReviewGridComponent,
    UploadDocumentsModalComponent
  ],
  providers: [CookieService, DatePipe, DecimalPipe, CurrencyPipe],
  exports: [
    ProducerDashboardComponent,
    ConnectureEnrollSsoComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class ProducerModule {
  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("ProducerModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist(
          'sxe-producer-landing-page',
          ProducerLandingPageComponent
        );
        this.createElementIfDoesNotExist('sxe-agency-page', AgencyPageComponent);
        this.createElementIfDoesNotExist(
          'sxe-producer-dashboard-page',
          ProducerDashboardComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-purl-dashboard-page',
          PurlDashboardComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-lines-of-business',
          ProducerLinesOfBusinessComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-sso-handler',
          SSOHandlerComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-reports-form',
          ProducerReportsGenerateComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-reports-list',
          ProducerReportsListComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-resources-list',
          ResourcesListComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-compact-agency',
          ProducerCompactAgencyComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-login-as-employer',
          ProducerLoginAsEmployerComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-producer-change-agency',
          ProducerChangeAgencyComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-health-sherpa-sso-page-interstitial',
          HealthSherpaSsoPageInterstitialComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-soa-dashboard',
          SoaDashboardComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-static-reports-download',
          StaticReportsDownloadComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-rate-guides-download',
          RateGuidesDownloadComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-resource-download',
          ResourceDownloadComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-mass-enrollment',
          MassEnrollmentComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-mass-upload-grid',
          MassUploadGridComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-mass-upload-grid-dashboard',
          MassUploadGridDashboardComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-mass-upload-grid-submission-log',
          MassUploadGridSubmissionLogComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-mass-upload',
          MassUploadComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-submission-log',
          SubmissionLogComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-state-based-find-a-doctor',
          StateBasedFindADoctorComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-saved-quotes',
          SavedQuotesComponent
        );

        this.createElementIfDoesNotExist(
          'sxe-view-plan',
          ViewPlanComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-passive-referrals',
          PassiveReferralsComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-passive-referral-loader',
          PassiveReferralLoaderComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-media-list',
          MediaListComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-dynamic-link-layout',
          DynamicLinkLayoutComponent
        );
        this.createElementIfDoesNotExist(
          'sxe-sep-application-review-dashboard',
          SepApplicationReviewDashboardComponent
        )
      }
      ModuleRegistry.registerModules([
        InfiniteRowModelModule,
        ServerSideRowModelModule,
        MasterDetailModule,
        RichSelectModule,
        ColumnsToolPanelModule,
        PaginationModule,
        ColumnApiModule,
        RowSelectionModule,
        RowAutoHeightModule,
        CellStyleModule,
        ValidationModule,
        RowApiModule,
        ClientSideRowModelApiModule,
        RenderApiModule,
        RowStyleModule,
        SetFilterModule,
        DateFilterModule,
        DateEditorModule,
        NumberEditorModule, 
        NumberFilterModule,
        TextFilterModule,
        TextEditorModule
      ]);
      LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-129056}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Highmark_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{29}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{6}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_May_2027}____[v2]_[01]_MTgxMTcxODAwMDAwMA==b63adc83a4cbf4ce9da8c786fd1d1afa")
    });
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }

  ngDoBootstrap() { }
}
